import { DmcMasterApi } from "api/dmcMaster.api";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { components } from "react-select";
import { CreateNewTourOptions } from "./CreateNewTourOptions";
import ReactHtmlParser from "react-html-parser";
import {
  IDMCTourOption,
  IDMCTourOptionWithActivity,
} from "commonFnBcode/types/dmc.types";
import { IJSONResponse } from "components/afterLogin/dashboard/flightApis/AirlineDiscountMarkup/types";
export const TourOptionByCitySelector: React.FC<{
  label: string;
  onSelect?: (tourOption: IDMCTourOptionWithActivity) => void;
  error?: string;
  selectedCityId?: number;
  value?: number;
  prevSelectedTourOptionId?: number;
  //   refreshTourOptions: number;
}> = (props) => {
  const [tourOptionsState, setTourOptionsState] = React.useState<
    Array<{
      label: string;
      value: any;
      icons: Array<string>;
      originalObject: any;
    }>
  >([]);

  const [inputState, setInputState] = useState("");
  //   const [selectedForEditId, setSelectedForEditId] = useState<number>();
  const [isPrevTourOptionSetState, setIsPrevTourOptionSetState] =
    useState(false);

  // const [selectedLabel, setSelectedLabel] = useState("");

  const getTourOptionsByCity = async () => {
    if (props.selectedCityId) {
      const tourOptionsRes: IJSONResponse<IDMCTourOptionWithActivity[]> =
        await DmcMasterApi.getTourOptionsByCity({
          cityId: props.selectedCityId,
        });

      setTourOptionsState(
        tourOptionsRes.result.map((tourOpt) => {
          let iconsArray: Array<string> = [];

          if (tourOpt.hasMeal) {
            iconsArray.push("fas fa-utensils");
          }
          if (tourOpt.hasGuide) {
            iconsArray.push("fas fa-hiking");
          }
          if (tourOpt.hasTicket) {
            iconsArray.push("fas fa-ticket-alt");
          }

          iconsArray.push();

          return {
            label: `${tourOpt.activity?.name} (${tourOpt.name})`,
            value: tourOpt.id,
            // icons: ["fas fa-utensils-alt", "far fa-person-sign"],
            icons: iconsArray,
            originalObject: tourOpt,
          };
        })
      );
    } else {
      setTourOptionsState([]);
    }
  };

  useEffect(() => {
    if (
      props.prevSelectedTourOptionId &&
      tourOptionsState.length > 0 &&
      props.onSelect &&
      !isPrevTourOptionSetState
    ) {
      const tourOptionSelected = tourOptionsState.find(
        (hotel) => hotel.value === props.prevSelectedTourOptionId
      );

      setInputState(tourOptionSelected?.label || "");
      setIsPrevTourOptionSetState(true);
      props.onSelect(tourOptionSelected?.originalObject);
    }
  }, [
    props.prevSelectedTourOptionId,
    tourOptionsState,
    props.onSelect,
    isPrevTourOptionSetState,
  ]);

  useEffect(() => {
    getTourOptionsByCity();
    setInputState("");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedCityId]);

  return (
    <div>
      {/* <i className="fas fa-car"></i> */}
      {/* {selectedForEditId && (
        <CreateNewTourOptions
          isModalOpen={true}
          handleModalClose={() => {
            setSelectedForEditId(undefined);
            getTourOptionsByCity();
          }}
          tourOptionId={selectedForEditId}
        />
      )} */}
      <Form.Text>{props.label}</Form.Text>
      <Select
        onChange={(val) => {
          if (props.onSelect && val) {
            props.onSelect(val.originalObject);
          }
        }}
        onInputChange={(val) => {
          setInputState(val);
        }}
        inputValue={inputState}
        value={
          props.selectedCityId
            ? {
                value: props.selectedCityId,
                label: tourOptionsState.find(
                  (tourOpt) => tourOpt.value === props.value
                )?.label,
                originalObject: tourOptionsState.find(
                  (tourOpt) => tourOpt.value === props.value
                )?.originalObject,
              }
            : undefined
        }
        isClearable
        // inputValue={selectedLabel}
        placeholder={props.label}
        options={tourOptionsState}
        components={{
          Option: (innerProps) => {
            const optionData = innerProps.data;

            // const iconsArray = ["fas fa-car"];
            const iconsArray = tourOptionsState.find(
              (tourOpt) => tourOpt.value === optionData.value
            )?.icons;

            // if (!optionData.length) return null;
            return (
              <components.Option {...innerProps}>
                <div className="d-flex align-items-center">
                  <div className="col px-0">
                    <span>{ReactHtmlParser(optionData.label)}</span>
                    {iconsArray?.map((icon, icIndx) => (
                      <i
                        className={`${icon} mx-1`}
                        key={"icn" + icIndx.toString()}
                      ></i>
                    ))}
                    {/* <i className="fas fa-car"></i> */}
                    {/* <span>
                      <button
                        onClick={() => {
                          setSelectedForEditId(optionData.value);
                        }}
                        className="btn btn-sm btn-outline-primary ms-1"
                      >
                        Edit
                      </button>
                    </span> */}
                  </div>
                </div>
              </components.Option>
            );
          },
          // Menu: (props) => (
          //   <components.Menu {...props} className="locationSelectMenu">
          //     {props.children}Edit
          //   </components.Menu>
          // ),
        }}
      />
      <Form.Control.Feedback type="invalid">
        {props?.error}
      </Form.Control.Feedback>
    </div>
  );
};
